import { render, staticRenderFns } from "./setChannel.vue?vue&type=template&id=fe3d4fb8&"
import script from "./setChannel.vue?vue&type=script&lang=js&"
export * from "./setChannel.vue?vue&type=script&lang=js&"
import style0 from "./setChannel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports